import * as constants from '../../../utils/constants/constants'
import { customerTypes } from '../../../utils/constants/misc'
import {
  textOperators,
  equalityOperators,
  multiselectOperators,
  dateOperators
} from '../../../utils/constants/operators'

export const getCustomerFields = () => [
  [
    {
      name: 'customer_name',
      label: 'Nom',
      required: true,
      type: 'text',
      fullWidth: true,
      validation: [
        { rule: 'req', error: 'Nom obligatoire' },
        { rule: 'minlen=3', error: 'Nom doit contenir au moins 3 caractères' },
        { rule: 'maxlen=20', error: 'Nom doit contenir moins de 20 caractères' }
      ]
    }
  ],
  [
    {
      name: 'customer_type',
      label: 'Type',
      required: true,
      type: 'select',
      fullWidth: true,
      options: {
        type: 'data',
        returnField: 'id',
        returnFields: ['id'],
        value: 'label',
        data: customerTypes
      },
      validation: [{ rule: 'req', error: 'Type obligatoire' }]
    }
  ],
  [
    {
      name: 'siren',
      label: 'SIREN',
      required: true,
      type: 'text',
      fullWidth: true,
      isDisplay: (data) => data.customer_type === 1,
      validation: [
        { rule: 'req', error: 'SIREN obligatoire' },
        { rule: `regex=${constants.REGEX_SIREN.source}`, error: 'SIREN doit contenir 9 chiffres' }
      ]
    },
    {
      name: 'siret',
      label: 'SIRET',
      required: true,
      type: 'text',
      fullWidth: true,
      isDisplay: (data) => data.customer_type === 1,
      validation: [
        { rule: 'req', error: 'SIRET obligatoire' },
        { rule: `regex=${constants.REGEX_SIRET.source}`, error: 'SIRET doit contenir 14 chiffres' }
      ]
    }
  ],
  [
    {
      name: 'address1',
      label: 'Adresse',
      required: true,
      type: 'text',
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Adresse obligatoire' }]
    }
  ],
  [
    {
      name: 'address2',
      label: "Complément d'adresse",
      type: 'text',
      fullWidth: true
    }
  ],
  [
    {
      name: 'zip',
      label: 'Code Postal',
      required: true,
      type: 'text',
      fullWidth: true,
      validation: [
        { rule: 'req', error: 'Code Postal obligatoire' },
        { rule: 'regex=^[0-9]{5}$', error: 'Code Postal doit contenir 5 chiffres' }
      ]
    },
    {
      name: 'city',
      label: 'Ville',
      type: 'text',
      required: true,
      fullWidth: true,
      validation: [{ rule: 'req', error: 'Ville obligatoire' }]
    }
  ],
  [
    {
      name: 'phone',
      label: 'Téléphone',
      required: true,
      type: 'text',
      fullWidth: true,
      validation: [
        { rule: 'req', error: 'Téléphone obligatoire' }
        // { rule: `regex=${constants.REGEX_PHONE.source}`, error: 'Téléphone doit contenir 10 chiffres' }
      ]
    },
    {
      name: 'email',
      label: 'Email',
      type: 'text',
      required: false,
      fullWidth: true,
      validation: [{ rule: 'email', error: "Format d'email invalide" }]
    }
  ]
]

export const customerColumns = [
  {
    name: 'customer_name',
    label: 'Nom Client',
    isFilter: true,
    operators: [...equalityOperators, ...multiselectOperators]
  },
  {
    name: 'customer_type',
    label: 'Type',
    isFilter: true,
    valueEditorType: 'multiselect',
    values: customerTypes,
    mapping: (id) => {
      const result = customerTypes.find((item) => item.id === id)
      return result ? result.label : id
    },
    operators: [...equalityOperators, ...multiselectOperators]
  },
  {
    name: 'city',
    label: 'Ville',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'phone',
    label: 'Téléphone',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'createdDateTime',
    label: 'Date Création',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'createdBy',
    label: 'Créé Par',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'lastModDateTime',
    label: 'Date Modification',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'lastModBy',
    label: 'Modifié Par',
    isFilter: true,
    operators: textOperators
  }
]
